import { useMutation, useQueryClient } from "@tanstack/react-query";
import { sendChatSms, SendSmsPayload } from "../../actions/sendChatSms.actions";
import { SmsMessage } from "../types/SmsMessage";
import { isAxiosError } from "axios";
import { SMS_CONTACTS_QUERY_KEY } from "../../contacts/hooks/useSmsContactsQuery";
import { useGlobalSnackbar } from "../../../../../context/SnackbarContext";

export const useChatSmsMutation = () => {
  const queryClient = useQueryClient();

  const { showSnackbar } = useGlobalSnackbar()

  const mutation = useMutation<SmsMessage, Error, SendSmsPayload>({
    mutationFn: sendChatSms,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...SMS_CONTACTS_QUERY_KEY] });
    },
    onError: (error: any) => {

      if (isAxiosError(error)) {
        const status = error.response?.status;

        if (status === 400) {
          showSnackbar("The phone number is invalid", "error");
          return;
        }

        const backendMessage =
          error.response?.data?.message ||
          error.message ||
          "Something went wrong";

        showSnackbar(
          Array.isArray(backendMessage) ? backendMessage[0] : backendMessage,
          "error"
        );
        return;
      }

      showSnackbar(error.message || "Something went wrong", "error");
    },
  });

  return mutation;
};